import React from "react";

const AdminMessagesHeader = () => {
  return (
    <div>
      <h2>
        Messages<span></span>
      </h2>
    </div>
  );
};

export default AdminMessagesHeader;
